import { FormControl, FormLabel, MenuItem, OutlinedInput, Select } from "@mui/material";
import { Contact } from "../../models/Types";
import { DataGrid, DataGridApiProps } from "../form/DataGrid";
import './person.css';

export function Contacts({ contacts, ...props }: { contacts: Contact[] } & DataGridApiProps<Contact>) {
    return <DataGrid<Contact>
        {...props}
        label="Контакты"
        addText="контакт"
        create={() => { return {}; }}
        entities={contacts}
        row={(c, i) => <>
            <FormControl>
                <FormLabel required>Тип</FormLabel>
                <Select defaultValue={c.Type} placeholder="Тип" label="Тип" onChange={e => c.Type = e.target.value}>
                    <MenuItem value="Phone">Телефон</MenuItem>
                    <MenuItem value="Email">E-mail</MenuItem>
                    <MenuItem value="Link">Ссылка</MenuItem>
                    <MenuItem value="Telegram">Telegram</MenuItem>
                    <MenuItem value="Instagram">Instagram</MenuItem>
                </Select>
            </FormControl>
            <FormControl>
                <FormLabel required>Данные</FormLabel>
                <OutlinedInput label="Данные" onChange={e => c.Value = e.target.value} defaultValue={c.Value} />
            </FormControl>
            <FormControl>
                <FormLabel>Примечание</FormLabel>
                <OutlinedInput label="Примечание" onChange={e => c.Description = e.target.value} defaultValue={c.Description} placeholder="Примечание" />
            </FormControl>
        </>} />;
}